import React from 'react'
import { useFormContext } from 'react-hook-form'
import { renderText } from '../utils'

function ContactFormConfirm({
  onSubmit,
  onFix,
  privacyPolicyPath,
  className,
  requireAddress,
}) {
  const { getValues, handleSubmit } = useFormContext()
  const formValues = getValues()
  const showAddressFields = requireAddress(formValues.inquiryType)

  return (
    <>
      <h2 className={className}>送信内容確認</h2>
      <div className="inquiry_area">
        <p className="note">
          <span className="red">※</span>は必須項目です。
        </p>
        <form name="contact" method="post" onSubmit={handleSubmit(onSubmit)}>
          <table className="contact">
            <tbody>
              <tr id="Cnt1">
                <th className="must">お問い合わせ種別</th>
                <td className="checkbox_square">
                  {formValues.inquiryType.map((inquiryType, index) => (
                    <span key={index}>{inquiryType}</span>
                  ))}
                </td>
              </tr>
              <tr id="Cnt2">
                <th className="must">お名前（漢字）</th>
                <td className="name">
                  <span>{formValues.nameKanji}</span>
                </td>
              </tr>
              <tr id="Cnt3">
                <th className="must">お名前（フリガナ）</th>
                <td className="name">
                  <span>{formValues.nameFurigana}</span>
                </td>
              </tr>
              <tr id="Cnt4" hidden={!showAddressFields}>
                <th>送付先ご住所</th>
                <td className="address">
                  <div className="address_list">
                    <span>郵便番号</span>
                    {formValues.postalCode}
                  </div>
                  <div className="address_list">
                    <span>都道府県</span>
                    {formValues.prefecture}
                  </div>
                  <div className="address_list">
                    <span>ご住所</span>
                    {formValues.address1}
                  </div>
                  <div className="address_list">
                    <span>建物名</span>
                    {formValues.address2}
                  </div>
                </td>
              </tr>
              <tr id="Cnt5">
                <th className="must">電話番号</th>
                <td className="tel">
                  <span>{formValues.tel}</span>
                </td>
              </tr>
              <tr id="Cnt6">
                <th className="must">メールアドレス</th>
                <td className="mail cont">
                  <span>{formValues.email}</span>
                </td>
              </tr>
              <tr>
                <th className="must">お問い合わせ内容</th>
                <td className="message">
                  <span>{renderText(formValues.inquiryBody)}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="send_area">
            <p>
              入力された情報は当院の
              <a
                href={privacyPolicyPath}
                target="_blank"
                rel="noreferrer noopener"
              >
                個人情報保護方針
              </a>
              に基づき取り扱われます。
            </p>
            <button>内容を送信する</button>
            <button
              className="fix"
              onClick={(e) => {
                e.preventDefault()
                onFix()
              }}
            >
              修正する
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export { ContactFormConfirm }
